var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 51C1 78.6142 23.3858 101 51 101C78.6142 101 101 78.6142 101 51C101 23.3858 78.6142 1 51 1C23.3858 1 1 23.3858 1 51Z",
    fill: "white",
    stroke: "url(#paint0_linear_720_5803)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 54.25V58.5833C60.75 59.158 60.5217 59.7091 60.1154 60.1154C59.7091 60.5217 59.158 60.75 58.5833 60.75H43.4167C42.842 60.75 42.2909 60.5217 41.8846 60.1154C41.4783 59.7091 41.25 59.158 41.25 58.5833V54.25",
    stroke: "#73C947",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4154 46.6667L50.9987 41.25L45.582 46.6667",
    stroke: "#73C947",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41.25V54.25",
    stroke: "#73C947",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_5803",
    x1: 1,
    y1: 1,
    x2: 101.945,
    y2: 92.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59DC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F4A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.dfab74f6d2338446b0ae84cd1cf1dbb7.svg";
export { ForwardRef as ReactComponent };